import React from "react";
import DisplayField from "../DisplayField";
import Contact from "./Contact";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import styles from "./AppointmentEvent.css";

const Details = ({ event }) => (
  <div>
    {event.customer && (
      <DisplayField group="details" field="customerName">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Customer
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.customer.name}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.datasheet && (
      <DisplayField group="details" field="customerName">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Datasheet
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.datasheet.name}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.datasheet && event.datasheet.customer && (
      <DisplayField group="details" field="customerName">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Customer
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.datasheet.customer.name}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.datasheet && event.datasheet.status && (
      <DisplayField group="details" field="jobStatus">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Status
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.datasheet.status}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.customer && event.customer.status && (
      <DisplayField group="details" field="jobStatus">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Status
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.customer.status}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.datasheet && event.datasheet.assignedToResource && (
      <DisplayField group="details" field="salesperson">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Salesperson
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.datasheet.assignedToResource.firstName}{" "}
            {event.datasheet.assignedToResource.lastName}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.customer && event.customer.assignedTo && (
      <DisplayField group="details" field="salesperson">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Salesperson
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.customer.assignedTo.firstName}{" "}
            {event.customer.assignedTo.lastName}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.description && (
      <DisplayField group="details" field="description">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Description
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.description}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.datasheet &&
      event.datasheet.customer &&
      event.datasheet.customer.phonenumber && (
        <DisplayField group="details" field="customerName">
          <FormGroup className={styles.dataValuePair}>
            <ControlLabel className={styles.dataValuePairLabel}>
              Phone
            </ControlLabel>
            <FormControl.Static
              className={styles.dataValuePairValue}
              componentClass={"div"}
            >
              {event.datasheet.customer.phonenumber}
            </FormControl.Static>
          </FormGroup>
        </DisplayField>
      )}

    {event.customer && event.customer.phonenumber && (
      <DisplayField group="details" field="customerName">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Phone
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.customer.phonenumber}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}

    {event.appttype && (
      <DisplayField group="details" field="customerName">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Appointment Type
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.appttype}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}
  </div>
);

export default Details;
